import React from "react";
import PropTypes from "prop-types";
import { motion } from "motion/react";

const AnimatedButton = ({
  href,
  ariaLabel,
  className = "",
  children,
  svg,
  ...rest
}) => (
  <motion.a
    whileHover="hover"
    href={href}
    aria-label={ariaLabel}
    className={className}
    {...rest}>
    {svg}
    {children}
  </motion.a>
);

AnimatedButton.propTypes = {
  href: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  svg: PropTypes.node,
};

export default AnimatedButton;
